/** @format */

export const tail = ([_, ...tail]) => tail
